import floatingCashier from '@/api/floating/floating-cashier'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from "lodash";
import moment from 'moment'

export const state = {
  ...baseState,
  dateRange: [
    moment().startOf('month').format('DD-MM-YYYY'),
    moment().endOf('month').format('DD-MM-YYYY')
  ],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: _.join(
            context.state.searchAllDate && context.state.search
              ? undefined
              : context.state.dateRange,
            ','
          )
        }
      },
      attrubutes
    )
    return floatingCashier.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return floatingCashier.store(data)
  },
  update(context, { id, data }) {
    return floatingCashier.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await floatingCashier.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  preview(context, id) {
    return floatingCashier.preview(id)
  },
  destroy(context, id) {
    return floatingCashier.destroy(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await floatingCashier.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
